import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
// import resume from '/AbhishekMallepalliTechnicalResume.pdf'
const Header = (props) => (
    <header id="header" className="alt">
        <Link to="/" className="logo"><strong>ABHI</strong></Link> <span> <a href='/AbhishekMallepalliTechnicalResume.pdf'>resume</a></span>
        <nav>
            <a className="menu-link" onClick={props.onToggleMenu} href="javascript:;">Menu</a>
        </nav>
    </header>
)

Header.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Header
